import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-assets',
  templateUrl: './assets.component.html'
})
export class AssetsComponent implements OnInit {

  @Output()
  formReady = new EventEmitter<FormGroup>()
  
  @Input() editBienesJson:any;
  
  assets:FormArray;
  formFields: any;

  form = this.fb.group({
    assets: this.fb.array([this.createItem()])
  });

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.formReady.emit(this.form);
    

    if(this.editBienesJson?.assets){
      console.log(this.editBienesJson);
      let length = this.editBienesJson.assets.length
      console.log(length);
      if( length > 1){
        length -= 1;
        while(length > 0 ){
          this.addItem();
          length -= 1;
        }
        this.form.patchValue(this.editBienesJson);
      }else{
        this.form.patchValue(this.editBienesJson);
      }
      
    }



    console.log(this.editBienesJson);
  }

  getControls() {
    return (this.form.get('assets') as FormArray).controls;
  }

  addItem(){
    this.assets = this.form.get('assets') as FormArray;
    this.assets.push(this.createItem());
    this.assets.updateValueAndValidity();
  }

  removeRow(index:any) {
    (<FormArray>this.form.get("assets")).removeAt(index);
  }

  createItem(){
    let group = this.fb.group({});

    this.formFields = [
      {
        title: "Tipo",
        formControlName: "type",
        type: "text"
      },
      {
        title: "Descripción",
        formControlName: "description",
        type: "text"
      },
      {
        title: "Valor del mercado",
        formControlName: "value",
        type: "number"
      },
      {
        title: "¿Colateral?",
        formControlName: "colateral",
        type: "radio",
        values: ["si", "no"]
      }
    ]
  
    for(let field of this.formFields){
      let formControl = new FormControl('',[Validators.required])
      group.addControl(field.formControlName, formControl);
    }
    return group;
  }

}
